<template>
  <v-container fluid>
    <breadcrumbs />
    <v-row>
      <v-col md="10">
        <h1 class="mb-1">
          SЕО страниц сайта
        </h1>
      </v-col>
      <v-col md="2" class="text-right">
        <v-btn
          depressed
          color="success"
          large
          @click="create"
        >
          <v-icon
            left
            v-text="`mdi-plus`"
          />
          Создать
        </v-btn>
      </v-col>
    </v-row>
    <loader v-if="loading" />
    <v-row v-else>
      <v-col>
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              outlined
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            fixed-header
            :search="search"
            :headers="headers"
            :items="items"
            :items-per-page="-1"
            class="elevation-1 menu-list"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.region="{ item }">
              <span v-if="item.region">{{ item.region.name }}</span>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.status="{ item }">
              <span v-if="item.status"><font-awesome-icon icon="check" /></span>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    class="mr-2"
                    elevation="1"
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="goToItem(item.id)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Редактировать</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="accent"
                    elevation="1"
                    icon
                    small
                    class="mb-2 mt-2"
                    v-bind="attrs"
                    v-on="on"
                    @click="openDeleteModal(item.id)"
                  >
                    <!-- eslint-disable-next-line -->
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Удалить</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            Вы действительно хотите удалить запись?
          </v-card-title>
          <v-card-text>
            Эту операцию невозможно будет отменить, вы точно хотите удалить?
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="closeModal">
              Отмена
            </v-btn>
            <v-btn
              :loading="deleting"
              color="red darken-1"
              text
              @click="deleteItem"
            >
              Согласен
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  import Loader from '@/components/loader/Loader'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    comments: {
      Loader,
    },
    mixins: [mixinSnackbarMessage],
    data () {
      return {
        loading: false,
        deleting: false,
        search: '',
        deleteId: null,
        dialog: false,
        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'URL', value: 'url', align: 'start' },
          { text: 'Регион', value: 'region', align: 'start' },
          { text: 'Статус', value: 'status', align: 'center' },
          { text: 'Действия', value: 'actions', align: 'end', sortable: false },
        ],
      }
    },
    computed: {
      ...mapState({
        items: (state) => state.seo.pageMetaList,
        /* 'regions',
        ['regions'], */
      }),
    },
    created () {
      this.loadList()
    },
    methods: {
      loadList () {
        this.loading = true
        return this.$store
          .dispatch('seo/fetchPageMetaList', {
            limit: 100000,
            offset: 0,
            page: 0,
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
          })
          .finally(() => {
            this.loading = false
          })
      },
      openDeleteModal (id) {
        this.deleteId = id
        this.dialog = true
      },
      closeModal () {
        this.deleteId = null
        this.dialog = false
      },
      deleteItem () {
        this.deleting = true
        this.$store
          .dispatch('seo/deletePageMeta', this.deleteId)
          .then(() => {
            this.closeModal()
            // this.loadRegions()
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
          })
          .finally(() => {
            this.deleting = false
          })
      },
      goToItem (id) {
        this.$router.push({ name: 'seoPageMetaEdit', params: { id: id } })
      },
      create () {
        this.$router.push({ name: 'seoPageMetaCreate' })
      },
    },
  }
</script>

<style scoped></style>
